import moment from "moment";

export const formatRelativeTime = (time: string | number | Date) => {
  return Number.isNaN(Number(time))
    ? moment(time).fromNow()
    : moment(new Date(Number(time))).fromNow();
};
